<template>
    <div class="body d-flex py-lg-3 py-md-2 mb-5">
        <div class="container-xxl">
            <h1 class="fw-bold page-title d-none">Προωθητικό υλικό</h1>
            <div class="row clearfix">
                <!-- PAPAGOU - XOLARGOS b2c -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'papagou-cholargou'">
                    <h2 class="text-primary fw-bold">B2C</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2C-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2C-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2C-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- nea ionia b2c -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neaionia'">
                    <h2 class="text-primary fw-bold">B2C</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2C-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2C-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2C-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ilioupoli b2c -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'ilioupoli'">
                    <h2 class="text-primary fw-bold">B2C</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2C-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2C-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2C-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- nea filadelfeia b2c -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neafiladelfeia'">
                    <h2 class="text-primary fw-bold">B2C</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2C-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2C-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2C-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- PAPAGOU - XOLARGOS b2b -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'papagou-cholargou'">
                    <h2 class="text-primary fw-bold">B2B</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2B-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2B-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/papagou-xolargou/B2B-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- nea ionia b2b -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neaionia'">
                    <h2 class="text-primary fw-bold">B2B</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2B-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2B-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/nea-ionia/B2B-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ilioupoli b2b -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'ilioupoli'">
                    <h2 class="text-primary fw-bold">B2B</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2B-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2B-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/ilioupoli/B2B-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- nea filadelfeia b2b -->
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neafiladelfeia'">
                    <h2 class="text-primary fw-bold">B2B</h2>
                    <hr>
                    <div class="row text-center flex-column-mobile">
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2B-1.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2B-2.jpg" alt="" width="75%">
                            </div>
                        </div>
                        <div class="col">
                            <div>
                                <img src="../assets/images/promo/filadelfeia-xalkidona/B2B-3.jpg" alt="" width="75%">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neaionia'">
                    <h2 class="text-primary fw-bold">Video</h2>
                    <hr>
                    <div class="row text-center ">
                        <div class="col">
                            <div style="width: 100%;">
                                <!-- <video src="../assets/images/promo/promo-video.mp4" width="100%" controls></video> -->
                                <iframe width="100%" height="550" src="https://www.youtube.com/embed/U6ZEO7xbWRM?si=_SHetu4zqf0h4_PE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'neafiladelfeia'" >
                    <h2 class="text-primary fw-bold">Video</h2>
                    <hr>
                    <div class="row text-center">
                        <div class="col">
                            <div style="width: 100%;">
                                <iframe width="100%" height="550" src="https://www.youtube.com/embed/AkP6UHL0PEw?si=GWQP1uyGXsT_mIkh" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'ilioupoli'">
                    <h2 class="text-primary fw-bold">Video</h2>
                    <hr>
                    <div class="row text-center">
                        <div class="col">
                            <div style="width: 100%;">
                                <iframe width="100%" height="550" src="https://www.youtube.com/embed/LkGLca4Ua6M?si=k2zwCCa6QRnmQreW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="shadow py-4 my-3 px-3 rounded" v-if="branch === 'papagou-cholargou'">
                    <h2 class="text-primary fw-bold">Video</h2>
                    <hr>
                    <div class="row text-center">
                        <div class="col">
                            <div style="width: 100%;">
                                <iframe width="100%" height="550" src="https://www.youtube.com/embed/mG-uFO4Ld8I?si=MfCSj0xej100Bmr8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import { fetchUserInfo, fetchUsers, changeUser } from '../services/user'; // Adjust this import as needed
import { getCurrentBusinessPartnerData } from '@/services/business-partners';

export default {

    setup() {
        const users = ref([]); // Ref to store fetched users
        const userInfo = ref(null); // Use cached user info if available
        const selectedUser = ref(null); // Ref to store selected user
        const showUsersContainer = ref(false); // Ref to control visibility of users container
        const router = useRouter();
        const partnerData = ref(false);

        const hostname = ref('');

        onMounted(() => {
            hostname.value = window.location.hostname;
        });

        // Map hostnames to branch keys
        const branch = computed(() => {
            if (hostname.value.includes('papagou-cholargou')) return 'papagou-cholargou';
            if (hostname.value.includes('neaionia')) return 'neaionia';
            if (hostname.value.includes('ilioupoli')) return 'ilioupoli';
            if (hostname.value.includes('neafiladelfeia')) return 'neafiladelfeia';
            return null;
        });

        const fetchUserData = async () => {
            try {
                const response = await fetchUserInfo();
                userInfo.value = response.data?.info || null;

                if (userInfo.value && userInfo.value.customer_id === null && userInfo.value.superUser === 1) {
                    showUsersContainer.value = true;
                } else {
                    showUsersContainer.value = false;
                }
            } catch (error) {
                console.error('Failed to fetch user data:', error);
            }
        };

        router.beforeEach(async (to, from, next) => {
            // Wait for the user data to be loaded
            if (!userInfo.value) {
                // If user data is still loading, proceed with the navigation and let the component load
                await fetchUserData(); // Ensure user data is loaded
            }

            const restrictedRoutes = ['BusinessPartners', 'AllBusinessPartnerRequests'];

            // Now check if the user is a super user and if the route is restricted
            if (restrictedRoutes.includes(to.name) && userInfo.value?.superUser === 0) {
                next({ path: '/' });
            } else {
                next();
            }
        });

        const getCurrentPartnerData = async () => {
            try {
                const response = await getCurrentBusinessPartnerData();
                partnerData.value = response.data.data || false;
            } catch (error) {
                console.error("Failed to fetch user data:", error);
            }
        };

        const changeUserHandler = async (userId) => {
            const userInfo = await fetchUserInfo();
            if (userInfo.data.info?.id) {
                if (userId && parseInt(userInfo.data.info?.id) != parseInt(userId)) {
                    const toast = useToast();
                    try {
                        const response = await changeUser(userId); // Call the changeUser function with the selected userId
                        if (response.data.success) {
                            // Update the Authorization header with the new token
                            const newToken = response.data.data.token.plainTextToken;

                            localStorage.removeItem('api_token');
                            localStorage.setItem('api_token', newToken);

                            await fetchUserData();

                            toast.success(response.data.message); // Show success message

                            // Reload the page
                            window.location.reload();
                        } else {
                            toast.error(response.data.message); // Show error message
                        }
                    } catch (error) {
                        console.error('Error changing user:', error);
                        toast.error('An error occurred while changing the user.'); // Show generic error message
                    }
                }
            }
        };

        onMounted(() => {
            getCurrentPartnerData();
            if (!userInfo.value) {
                fetchUserData(); // Fetch user info if not already cached
            }
        });

        return {
            partnerData,
            userInfo,
            users,
            selectedUser,
            showUsersContainer,
            changeUserHandler,
            branch
        };

    },

    metaInfo: {
        title: 'Πρωοθητικό υλικό',
        meta: [
            { name: 'description', content: 'Πρωοθητικό υλικό' },
            { property: 'og:title', content: 'Πρωοθητικό υλικό' },
            { property: 'og:description', content: 'Πρωοθητικό υλικό' }
        ]
    }
};
</script>

<style scoped></style>
